import React from "react";

function Profile() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <path
        fill="#006778"
        fill-rule="nonzero"
        d="M5.557 9.707l.014-.008c1.42.902 2.958.986 4.613.25a.54.54 0 0 1 .774-.19c.016.01 1.477.98 3.234 1.409l.038.01c1.691.552 1.742 2.278 1.765 3.016 0 .034.004.064.004.093v.012c.004.193.008 1.189-.187 1.684a.504.504 0 0 1-.203.235C15.493 16.29 12.692 18 8.006 18S.519 16.293.402 16.218a.484.484 0 0 1-.202-.235c-.207-.499-.203-1.494-.199-1.688v-.011c.004-.03.004-.06.004-.093.023-.735.074-2.46 1.765-3.016l.038-.011c1.765-.429 3.218-1.398 3.234-1.41a.543.543 0 0 1 .515-.047zm2.375-.008C6.79 9.68 5.867 9.296 5.19 8.562c-1.5-1.618-1.25-4.391-1.224-4.656C4.064 1.905 5.061.954 5.88.511 6.693.067 7.542 0 7.975 0h.066c.787.015 1.492.194 2.096.526.81.443 1.791 1.394 1.889 3.38.027.265.276 3.038-1.223 4.656-.682.734-1.605 1.118-2.747 1.137h-.124z"
      />
    </svg>
  );
}

export default Profile;
